import { render, staticRenderFns } from "./DoughtnutChart.vue?vue&type=template&id=380ad67b&scoped=true&"
import script from "./DoughtnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughtnutChart.vue?vue&type=script&lang=js&"
import style0 from "./DoughtnutChart.vue?vue&type=style&index=0&id=380ad67b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ad67b",
  null
  
)

export default component.exports